import isUUID from "validator/lib/isUUID";
import { createTranslator } from "short-uuid";

export const normalizeUUID = (str: string, { allowString = false }: { allowString?: boolean }): string => {
  if (isUUID(str)) {
    return str;
  }
  try {
    return createTranslator().toUUID(str);
  } catch (e) {
    if (allowString ?? false) {
      return str;
    }

    throw e;
  }
};

export const shortenUUID = (uuid: string): string => {
  return createTranslator().fromUUID(uuid);
};
